export enum GenericEvents {
	CLICK_BREADCRUMB = 'click_breadcrumb',
	PDP_ACTION = 'pdp_action',
	SHOW_SIZE_SELECTOR = 'show_size_selector',
	CLICK_SIZE = 'click_size',
	CLICK_SIZE_GUIDE = 'click_size_guide',
}
